/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'fabric.linkPicker.button.cancel': '取消',
  'fabric.linkPicker.button.insert': '插入',
  'fabric.linkPicker.button.save': '儲存',
  'fabric.linkPicker.clearLink': '清除',
  'fabric.linkPicker.clearLinkText': '清除文字',
  'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {沒有找到任何結果} other {找到 {count,number} 個結果}}',
  'fabric.linkPicker.linkAriaLabel': '在欄位中輸入或貼上連結',
  'fabric.linkPicker.linkInvalid': '請輸入有效的 URL。',
  'fabric.linkPicker.linkLabel': '連結',
  'fabric.linkPicker.linkPlaceholder': '貼上連結',
  'fabric.linkPicker.linkTextAriaLabel': '連結顯示文字',
  'fabric.linkPicker.linkTextLabel': '顯示文字 (選擇性)',
  'fabric.linkPicker.linkTextPlaceholder': '要顯示的文字',
  'fabric.linkPicker.listTitle.recentlyViewed': '最近檢視的項目',
  'fabric.linkPicker.listTitle.results': '結果',
  'fabric.linkPicker.search.error.description': '請重新整理頁面，如果持續發生錯誤，請連絡 <a>Atlassian 支援人員</a>。',
  'fabric.linkPicker.search.error.heading': '我們在載入資料時遇到問題。',
  'fabric.linkPicker.search.linkAriaLabel': '當您在欄位中輸入內容時，建議會顯示在下方',
  'fabric.linkPicker.search.linkLabel': '搜尋或貼上連結',
  'fabric.linkPicker.search.linkPlaceholder': '尋找最近的連結或貼上新連結',
  'fabric.linkPicker.search.noResults.description': '請使用不同的字詞再試一次。',
  'fabric.linkPicker.search.noResults.heading': '我們找不到任何符合您搜尋的項目。',
  'fabric.linkPicker.status.submitting': '正在提交',
  'fabric.linkPicker.time.message.updated': '更新時間：{time}',
  'fabric.linkPicker.time.message.viewed': '檢視時間：{time}',
  'fabric.linkPicker.unhandledError.description': '請嘗試重新載入頁面。',
  'fabric.linkPicker.unhandledError.heading': '發生錯誤！'
};